/* eslint-disable @typescript-eslint/ban-ts-comment */

import set from 'lodash/set';
import { FORM_ERROR } from 'final-form';
import get from 'lodash/get';

// eslint-disable-next-line import/no-cycle
import { stringifyIfObject, logError, logDebug } from 'shared/functions/utils';

const bodyPrefix = '.body.';
export const returnFinalFormError =
  (values: any, bodyFieldsToFieldNames = {}) =>
  (err: any) => {
    const payloadErrors = err.payload?.errors;
    if (Array.isArray(payloadErrors)) {
      return payloadErrors.reduce((prev, { path, message }) => {
        const [firstPathItem = ''] = path;
        const shiftedPath = firstPathItem.startsWith(bodyPrefix) ? firstPathItem.replace('.body.', '') : path.join('.');

        const pathInForm = bodyFieldsToFieldNames[shiftedPath] || shiftedPath;

        if (pathInForm in values) {
          set(prev, pathInForm, message);
        } else {
          set(prev, FORM_ERROR, message);
        }
        return prev;
      }, {});
    }
    if (err.payload?.error) {
      return {
        [FORM_ERROR]: typeof err.payload.error === 'string' ? err.payload.error : stringifyError(err.payload.error),
      };
    }
    return {
      [FORM_ERROR]: typeof err === 'string' ? err : stringifyError(err),
    };
  };

export const getErrorsFromBulkResponse = (response: any) =>
  Object.entries(response.results || response).reduce((prev, [id, response]) => {
    // @ts-expect-error
    const message = response?.error || get(response, 'errors[0].message');
    if (message) {
      return {
        ...prev,
        [id]: {
          errors: [
            {
              message,
            },
          ],
        },
      };
    }
    return prev;
  }, {});

export const getMetaError = (meta: any) => {
  const { dirty, touched, submitFailed, error, submitError } = meta || {};
  if (dirty || touched || submitFailed) {
    return error || submitError;
  }
};

export const checkBulkResponseErrors = (response: any) => {
  if (response.results) {
    const resultsValues = Object.values(response.results);
    if (
      // @ts-expect-error
      resultsValues.every((resultsValue) => resultsValue?.result === 'Success')
    ) {
      return;
    }
    return (
      resultsValues
        // @ts-expect-error
        .map((resultsValue) => resultsValue.error || resultsValue.errors)
        .filter((item) => item)
        .join(', ')
    );
  }
};

const getMessageWithPath = ({ message, path }) => {
  if (typeof message === 'string') {
    const pathPrefix = Array.isArray(path) && path.length ? `${path.join('.')}: ` : '';
    return `${pathPrefix}${message}`;
  }
  return stringifyIfObject(message);
};

export const stringifyError = (initialErr: any) => {
  const err = initialErr?.error?.payload ? initialErr.error : initialErr;
  if (!err || typeof err !== 'object') {
    logDebug(err);
    return `Unexpected error type ${err}`;
  } else if (!err.payload) {
    const unexpectedErrorFormat = JSON.stringify(err);
    logDebug(unexpectedErrorFormat);
    return `Unexpected error format: ${unexpectedErrorFormat}`;
  }
  const {
    payload: { error, errors, ...rest },
  } = err;
  if (errors) {
    return errors.map(getMessageWithPath).join(', ');
  } else if (rest.message) {
    return getMessageWithPath(rest);
  } else if (error) {
    return stringifyIfObject(error);
  }

  logDebug(JSON.stringify(err));
  return 'Unknown error format!';
};

export const removePathsFromError = (initialErr: any) => {
  const err = initialErr?.error?.payload ? initialErr.error : initialErr;

  if (!err || typeof err !== 'object') {
    logError(err);
    return `Unexpected error type ${err}`;
  } else if (!err.payload) {
    logError(err);
    return `Unexpected error format: ${JSON.stringify(err)}`;
  }

  if (err.payload.errors) {
    err.payload.errors = err.payload.errors.map(({ path, ...err }) => err);
  } else if (err.payload.message) {
    delete err.payload.message.path;
  }
  return err;
};
